export default __webpack_public_path__ + "static/media/com.87f5baf5.png";